import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import * as actions from './state/actions';

import { Filter, Main } from 'Containers';
import ImportLogForm from './components/ImportLogForm';
import { FieldEnum } from 'Common/FieldEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import { NotificationMessage } from 'Components';
import { IMPORT_LOG_FORM_NAME } from 'Common/FormEnum';
import { ReportGeneration } from 'Common/ObjectHelper';

class ImportLogContainer extends Component {
  componentWillUnmount() {
    this.props.clearReport();
  }

  componentWillReceiveProps(nextProps) {
    const { error } = nextProps.importLogReport;
    if (error && error !== this.props.importLogReport.error) {
      NotificationMessage(error);
    }

    if (
      nextProps.importLogReport.report &&
      !this.props.importLogReport.report
    ) {
      const { report } = nextProps.importLogReport;
      const data = report.replace('data:application/pdf;base64,', '');

      if (data === null || data === '') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'ImportLogReport');
      }
    }
  }

  formSubmit = values => {
    let startDT = values[FieldEnum.FromDate];
    let endDT = values[FieldEnum.ToDate];

    if (values[FieldEnum.AllDates]) {
      startDT = new Date();
      endDT = new Date();
    }

    const model = {
      Reason: values[FieldEnum.StudentImportFailReason],
      ImportStartDT: startDT,
      ImportEndDT: endDT,
      CheckedAll: values[FieldEnum.AllDates],
    };

    this.props.clearReport();
    this.props.getImportLogReport(model);
  };

  getMainProps = () => {
    const { fetching } = this.props.importLogReport;

    return {
      toolbox: {
        formName: IMPORT_LOG_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          disabled: fetching,
          loading: fetching,
        },
        shown: true,
      },
    };
  };

  render() {
    return (
      <Fragment>
        <Filter title={'Import Log'} />
        <Main {...this.getMainProps()}>
          <ImportLogForm
            onSubmit={this.formSubmit}
            initialValues={{
              [FieldEnum.StudentImportFailReason]: 0,
              [FieldEnum.FromDate]: moment()
                .add(-1, 'days')
                .format('MM/DD/YYYY'),
              [FieldEnum.ToDate]: moment().format('MM/DD/YYYY'),
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ ImportLogState }) => {
  return {
    importLogReport: ImportLogState.importLogReport,
  };
};

export const ImportLog = withRouter(
  connect(
    mapStateToProps,
    actions
  )(ImportLogContainer)
);



// WEBPACK FOOTER //
// ./src/pages/importlog/ImportLog.js